<template>
	<BaseRow :disabled="!value.is_enabled" @click="redirectToTarget">
		<PrefixIconColumn :icon="getIcon" :value="getName" />
		<BaseColumn class="pl-6" :value="getId" />
		<BaseColumn class="pl-6">
			<div>{{ street }}</div>
			<div>{{ city }}</div>
		</BaseColumn>
		<SuffixColumn />
	</BaseRow>
</template>
<script>
import { concatArray } from '@/plugins/Utils';
import Authentication from '@/mixins/Authentication';
import BaseRow from '@/components/rows/BaseRow';
import BaseColumn from '@/components/columns/BaseColumn';
import PrefixIconColumn from '@/components/columns/PrefixIconColumn';
import SuffixColumn from '@/components/columns/SuffixColumn';
import BaseCardRow from '@/components/damagecases/forms/BaseCardRow';

export default {
	name: 'DamageAssessorCompanyRow',
	components: { BaseCardRow, SuffixColumn, PrefixIconColumn, BaseColumn, BaseRow },
	mixins: [Authentication],
	props: {
		value: {},
		companyType: {},
	},
	methods: {
		redirectToTarget() {
			this.$router.push({ name: 'damageassessor.IndexCompanies.show', params: { id: this.value.company.id } });
		},
	},
	computed: {
		street: function() {
			if (this.value.poBox != null) {
				return this.$t('po_box') + ' ' + this.value.poBox;
			}
			return concatArray([this.value.street, this.value.houseNumber]);
		},
		city() {
			return concatArray([this.value.city.zipCode, this.value.city.name]);
		},
		getIcon() {
			switch (this.$route.params.type) {
				case 'repairShop':
					return 'city';
				case 'car_dealership':
					return 'tools';
			}
			return '';
		},
		getId() {
			return this.value.id;
		},
		getName() {
			return this.value.name;
		},
		getLocation() {
			return this.value.city.zipCode + ' ' + this.value.city.name;
		},
		getOwnerName() {
			return concatArray([this.value.ownerFirstname, this.value.ownerLastname]);
		},
	},
};
</script>
